import axios from "axios";
import { REACT_APP_API_URL } from "../env";

export const fetchLeaveMaster = async () => {
  const response = await axios.get(
    `${REACT_APP_API_URL}api/hrms/leave-types`
  );
  return response.data.data;
};
